export const ProviderTypes = {
	261: "Omniplay",
	54: "Golden race",
};
